<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import appConfig from "@/app.config.json";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import Loader from "../components/loader.vue";
import api from "@/axios";
import DropZone from "@/components/widgets/dropZone.vue";
import DropZoneMultiple from "@/components/widgets/dropZoneMultiple.vue";
import moment from "moment/moment";
import router from "@/router";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Importar Arquivo CT-e",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {Layout, PageHeader, Loader, DropZone, DropZoneMultiple, Multiselect },
  setup() {
    // let dropzoneFile = ref("");
    // const drop = (e) => {
    //   dropzoneFile.value = e.dataTransfer.files[0]
    // };

    return { v$: useVuelidate() };
  },
  data() {
    return {

      impVarios: false,
      dtlistPesqProduto: null,
      loadingProduto: false,

      textConfAlteracoesFornec: 'Confirmar Novo Cadastro de Fornecedor',

      ultPedsData: null,
      dtlistPesqNotaItem: null,
      showModalNotaItem: false,

      showModalDest: false,
      showModalReceb: false,
      showModalExped: false,
      showModalRemet: false,
      showModalEmit: false,
      loadingFornec: false,
      loadingPedTipo: false,
      dtlistPesqPedTipo: null,
      showModalPedTipo: false,
      selecArquivo: true,
      dropzoneFile: '',
      errosValid: null,
      contClickAvanc: 0,
      emitCompData: {},
      pedTipoData: {},
      emitData: {},
      faturasData: {},
      faturasParcData: {},
      transpData: {},
      itensCteData: {},
      movCteData: {},
      notaItemData: null,
      enderecosData: {},
      idData: 0,
      updating: true,
      activeTab: 0,
      submitted: false,

      remetCompData: {},
      remetData: {},

      expedCompData: {},
      expedData: {},

      recebCompData: {},
      recebData: {},

      destCompData: {},
      destData: {},

      impData: {},

      title: "Importar Arquivo CT-e",
      items: [
        {
          text: "Transportador",
          href: "/cteentradas/list",
        },
        {
          text: "Importar Arquivo CT-e",
          active: true,
        },
      ],
    };
  },
  validations: {
    movCteData: {
      nome: {
        required: helpers.withMessage("Campo nome obrigatório, favor preencher.", required),
      },
      email: {
        required: helpers.withMessage("Campo email obrigatório, favor preencher.", required),
      },
      cnpj: {
        required: helpers.withMessage("Campo CNPJ obrigatório, favor preencher.", required),
      },
      tipo: {
        required: helpers.withMessage("Campo Tipo obrigatório, favor preencher.", required),
      },
      codigo: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
      cep: {
        required: helpers.withMessage("Campo CEP obrigatório, favor preencher.", required),
      },
      rua: {
        required: helpers.withMessage("Campo logradouro obrigatório, favor preencher.", required),
      },
      bairro: {
        required: helpers.withMessage("Campo bairro obrigatório, favor preencher.", required),
      },
      numero: {
        required: helpers.withMessage("Campo número obrigatório, favor preencher.", required),
      },
      cidade: {
        required: helpers.withMessage("Campo cidade obrigatório, favor preencher.", required),
      },
      estado: {
        required: helpers.withMessage("Campo estado obrigatório, favor preencher.", required),
      },
    }
  },
  methods: {

    pesqProduto(evt){
      console.log('pesqProduto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.dtlistPesqProduto = null
        this.loadingProduto = true
        api.get(`${getBaseUrl()}api/prodpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          // //console.log(res.data.length)
          this.dtlistPesqProduto = res.data


        })
      }
    },


    escolheuProduto(){
      console.log('escolheuProduto')
      this.loadingProduto = true
      api.get(`${getBaseUrl()}api/prodcod`, {
        params: { coddata: this.notaItemData.produto }
      }).then((res) => {
        console.log('then axios_escolheu_produto')
        console.log(res.data)


        this.notaItemData.descprod = res.data[0]['descricao']
        this.notaItemData.idprod = res.data[0]['id']


        //     = {
        //   movcte_id: this.idData,
        //   produto: res.data[0]['codigo'],
        //   descprod: res.data[0]['descricao'],
        //   und: res.data[0]['unidade'],
        //   vlrunitliq: res.data[0]['preco'],
        //   vlrunitbrt: res.data[0]['preco'],
        //   vlrtotalliq: res.data[0]['preco'],
        //   vlrtotalbrt: res.data[0]['preco'],
        //   saldo: res.data[0]['saldo'],
        //   //img1: res.data[0]['imgs'],
        //   img1: img1,
        //   qtd: 1
        // }


        this.loadingProduto = false
      })
    },


    abrirMov(){
      console.log('abrirMov')

      //
      const routeData = this.$router.resolve(`/movcte/editar/${this.movCteData.id}`)
      window.open(routeData.href, '_blank')


    },

    confirmarImp(){
      console.log('confirmarImp')


      // if (!this.emitCompData.id) {
      //   Swal.fire({
      //     position: "top-end",
      //     icon: "warning",
      //     title: "Favor confirmar cadastro de novo emitente antes da confirmação",
      //     showConfirmButton: false,
      //     timer: 1500
      //   })
      // }



          Swal.fire({
            position: "center",
            icon: "question",
            title: "Importar CTE",
            text: `Confirma importação do arquivo e gerar um novo cte?`,
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            showCancelButton: true,
            showConfirmButton: true,

          }).then(result => {
            // this.updating = true
            if (result.value) {
              console.log('confirmarImp_01')
              console.log(this.remetCompData)
              console.log(this.expedCompData)
              this.updating = true

              api.post(`${getBaseUrl()}api/movcteimpxml`, {

                movCteData: this.movCteData,
                emitData: this.emitCompData,
                remetData: this.remetCompData,
                expedData: this.expedCompData,
                recebData: this.recebCompData,
                destData: this.destCompData,
                movCteItens: this.itensCteData

              }).then((res) => {
                console.log('then axios')
                console.log(res.data[0])
                const movNova = res.data[0]
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Movimento confirmado com sucesso!",
                  showConfirmButton: false,
                  timer: 1500
                }).then(() => {
                  console.log('finalizou confirmacao')
                  console.log(movNova)
                  this.$router.push('/movcte/editar/' + movNova.id)
                })

              }).catch((err) => {
                console.log('erro axios')
                // console.log(err)
                // console.log(err.response)
                // console.log(err.response.data.errors)
                let erros = err.response.data.errors
                console.log(erros)
                console.log(typeof  erros)
                let listaErros = []
                Object.keys(erros).forEach(key => {
                  console.log(key, erros[key]);
                  listaErros.push({
                    'titulo': key,
                    'mensagem': erros[key]
                  })
                });
                this.errosValid = listaErros
                this.updating = false
                this.activeTab = 0
              })

            }
          })


      // }





    },


    imporTodosProd(){
      console.log('imporTodosProd')

      let totalImportar = 0
      let prodsImport = []
      let possuiSemGtin = false
      this.itensCteData.forEach((value) => {
        if (value.produto.includes('SEM GTIN')){
          possuiSemGtin = true
        }
        if (value.idprod === 0){
          totalImportar++
          prodsImport.push({
            'codigo' : value.produto,
            'descricao' : value.descprod,
            'unidade' : value.und,
            'codfis' : value.ncm,
            'codfor' : value.codfor,
            'status' : 'A',
          })
        }
      })

      if (possuiSemGtin === true){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Produto a ser importado não pode ter definição SEM GTIN no código, favor corrigir",
          showConfirmButton: false,
          timer: 2500
        })
      }

      else if (totalImportar === 0){

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhum produto tem necessidade de ser importado",
          showConfirmButton: false,
          timer: 1500
        })

      } else {

        Swal.fire({
          position: "center",
          icon: "question",
          title: "Importar Todos os Produtos",
          text: `Confirmar importação de ${totalImportar} novo(s) produto(s)?`,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {

          if (result.value) {
            this.updating = true
            console.log('confProduto_01')

            api.post(`${getBaseUrl()}api/prlist`, {
              produtosData: prodsImport
            }).then((res) => {
              console.log('then axios')
              console.log(res)

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Produto(s) importado(s) com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })

              this.itensCteData.forEach((valueIt) => {
                res.data[0].forEach((valueRt) => {
                  if (valueIt.produto === valueRt.codigo){
                    valueIt.idprod = valueRt.id
                  }
                })
              })

              this.updating = false
            }).catch((err) => {
              console.log('erro axios')
              // console.log(err)
              // console.log(err.response)
              // console.log(err.response.data.errors)
              let erros = err.response.data.errors
              console.log(erros)
              console.log(typeof  erros)
              let listaErros = []
              Object.keys(erros).forEach(key => {
                console.log(key, erros[key]);
                listaErros.push({
                  'titulo': key,
                  'mensagem': erros[key]
                })
              });
              this.errosValid = listaErros
              this.updating = false
              this.activeTab = 0
            })


          }
        })


      }
    },


    confProduto(){
      console.log('confProduto')
      console.log(this.notaItemData.idprod)
      this.showModalNotaItem = false

        this.updating = true

        api.post(`${getBaseUrl()}api/produto`, {
          produtoData: {
            'id': this.notaItemData.idprod,
            'codigo' : this.notaItemData.produto,
            'descricao' : this.notaItemData.descprod,
            'unidade' : this.notaItemData.und,
            'codfis' : this.notaItemData.ncm,
            'codfor' : this.notaItemData.codfor,
            'status' : 'A',

          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: this.notaItemData.idprod > 0 ? "Produto associado com sucesso!" : "Novo produto importado com sucesso!",
            showConfirmButton: false,
            timer: 2500
          })

          // this.emitCompData = res.data[0]
          const indexItem = this.notaItemData['seq'] - 1
          this.itensCteData[indexItem].idprod = res.data[0].id

          this.updating = false

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })

    },


    confEmit(){
      console.log('confEmit')
      this.showModalEmit = false
      this.updating = true

      api.post(`${getBaseUrl()}api/cliente`, {
        clienteData: this.emitCompData
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Emitente salvo com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        this.emitCompData = res.data[0]
        this.updating = false



      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })
    },


    confRemet(){
      console.log('confRemet')
      this.showModalRemet = false
      this.updating = true

      api.post(`${getBaseUrl()}api/cliente`, {
        clienteData: this.remetCompData
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Remetente salvo com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        this.remetCompData = res.data[0]
        this.updating = false



      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })
    },


    confExped(){
      console.log('confExped')
      this.showModalExped = false
      this.updating = true

      api.post(`${getBaseUrl()}api/cliente`, {
        clienteData: this.expedCompData
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Expedidor salvo com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        this.expedCompData = res.data[0]
        this.updating = false



      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })
    },


    confReceb(){
      console.log('confReceb')
      this.showModalReceb = false
      this.updating = true

      api.post(`${getBaseUrl()}api/cliente`, {
        clienteData: this.recebCompData
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Recebedor salvo com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        this.recebCompData = res.data[0]
        this.updating = false



      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })
    },


    confDest(){
      console.log('confDest')
      this.showModalDest = false
      this.updating = true

      api.post(`${getBaseUrl()}api/cliente`, {
        clienteData: this.destCompData
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Destinatário salvo com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        this.destCompData = res.data[0]
        this.updating = false



      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })
    },


    abrirModalItem(item) {
      console.log('abrirModalItem')
      console.log(item)
      if (item.idprod > 0){
        // this.$router.push(`/produto/editar/${item.idprod}`);

        const routeData = this.$router.resolve(`/produto/editar/${item.idprod}`)
        window.open(routeData.href, '_blank')

      }else{
        this.notaItemData = item
        this.showModalNotaItem = true
      }
    },


    escolheuPedTipo(){
      console.log('escolheuPedTipo')
      this.loadingPedTipo = true
      console.log(this.movCteData.tipo)
      api.get(`${getBaseUrl()}api/tpoprcod`, {
        params: { coddata: this.movCteData.tipo }
      }).then((res) => {
        console.log('then axios_escolheu_ped_tipo')
        console.log(res.data)
        this.pedTipoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosCli = totalPed
        this.loadingPedTipo = false
      })
    },

    pesqPedTipo(evt){
      console.log('pesqPedTipo')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingPedTipo = true
        this.movCteData.tipo = ''
        api.get(`${getBaseUrl()}api/tpoprpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqPedTipo = res.data
        })
      }
    },

    selectedFiles() {
      console.log('selectedFiles')
      let arquivos = document.querySelector(".dropzoneFiles").files
      console.log(arquivos)
      console.log(typeof arquivos)
      console.log(Object.keys(arquivos).length)
      this.updating = true

      let formData = new FormData();
      let totalArqs = Object.keys(arquivos).length
      let cont = 0

      // console.log('totalArqs')
      // console.log(totalArqs)
      while (cont < totalArqs) {
        // console.log('arquivos[cont]')
        // console.log(arquivos[cont])
        formData.append("file" + cont, arquivos[cont]);
        cont++
      }

      console.log('formData')
      console.log(formData)

      api.post(`${getBaseUrl()}api/movctefiles`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then((res) => {
            console.log('then axios_movctefiles')
            console.log(res.data)

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              router.push('/movctes/listnova');
            })

            // }).then({
            //   this.$router.push('/movctes/listnova')
            // })



      }).catch((err) => {
        console.log('erro axios')
        console.log(err)
        // // console.log(err.response)
        // // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        // console.log(erros)
        // console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
      })

    },


    traduzirCte(resData){
      this.movCteData = resData[0]
      this.emitData = resData[1]
      this.remetData = resData[2]
      this.expedData = resData[3]
      this.recebData = resData[4]
      this.destData = resData[5]


      // this.faturasData = resData[2]
      // this.transpData = resData[3]
      // this.itensCteData = resData[4]
      // this.pedTipoData = resData[5]

      this.movCteData.dtemissao = this.formatDateTime(this.movCteData.dtemissao)
      this.movCteData.dtsaida = this.formatDateTime(this.movCteData.dtsaida)

      if (resData[6]){
        this.emitCompData = resData[6]
        this.textConfAlteracoesFornec = 'Confirmar Alterações Cadastro de Emitente'
      }else{
        this.emitCompData = {
          'nome':  this.emitData['nome'],
          'fantasia':  this.emitData['nome'],
          'cnpj':  this.emitData['cnpj'],
          'inscricao':  this.emitData['inscricao'],
          'rua':  this.emitData['rua'],
          'numero':  this.emitData['numero'],
          'bairro':  this.emitData['bairro'],
          'cep':  this.emitData['cep'],
          'cidade':  this.emitData['cidade'],
          'tel1':  this.emitData['tel1'],
          'estado':  this.emitData['estado'],
          'status': 'A',
          'classe': 'FO'
        }
      }


      if (resData[7]){
        this.remetCompData = resData[7]
        this.textConfAlteracoesFornec = 'Confirmar Alterações Cadastro de Remetente'
      }else{
        this.remetCompData = {
          'nome':  this.remetData['nome'],
          'fantasia':  this.remetData['nome'],
          'cnpj':  this.remetData['cnpj'],
          'inscricao':  this.remetData['inscricao'],
          'rua':  this.remetData['rua'],
          'numero':  this.remetData['numero'],
          'bairro':  this.remetData['bairro'],
          'cep':  this.remetData['cep'],
          'cidade':  this.remetData['cidade'],
          'tel1':  this.remetData['tel1'],
          'estado':  this.remetData['estado'],
          'status': 'A',
          'classe': 'FO'
        }
      }


      if (resData[8]){
        this.expedCompData = resData[8]
        this.textConfAlteracoesFornec = 'Confirmar Alterações Cadastro de Expedidor'
      }else{

        if (this.expedData) {

          this.expedCompData = {
            'nome': this.expedData['nome'],
            'fantasia': this.expedData['nome'],
            'cnpj': this.expedData['cnpj'],
            'inscricao': this.expedData['inscricao'],
            'rua': this.expedData['rua'],
            'numero': this.expedData['numero'],
            'bairro': this.expedData['bairro'],
            'cep': this.expedData['cep'],
            'cidade': this.expedData['cidade'],
            'tel1': this.expedData['tel1'],
            'estado': this.expedData['estado'],
            'status': 'A',
            'classe': 'FO'
          }
        }
      }

      if (resData[9]){
        this.destCompData = resData[9]
        this.textConfAlteracoesFornec = 'Confirmar Alterações Cadastro de Destinatário'
      }else{
        this.destCompData = {
          'nome':  this.destData['nome'],
          'fantasia':  this.destData['nome'],
          'cnpj':  this.destData['cnpj'],
          'inscricao':  this.destData['inscricao'],
          'rua':  this.destData['rua'],
          'numero':  this.destData['numero'],
          'bairro':  this.destData['bairro'],
          'cep':  this.destData['cep'],
          'cidade':  this.destData['cidade'],
          'tel1':  this.destData['tel1'],
          'estado':  this.destData['estado'],
          'status': 'A',
          'classe': 'FO'
        }
      }

      if (resData[10]){
        this.recebCompData = resData[10]
        this.textConfAlteracoesFornec = 'Confirmar Alterações Cadastro de Recebedor'
      }else{

        if (this.recebData) {
          this.recebCompData = {
            'nome':  this.recebData['nome'],
            'fantasia':  this.recebData['nome'],
            'cnpj':  this.recebData['cnpj'],
            'inscricao':  this.recebData['inscricao'],
            'rua':  this.recebData['rua'],
            'numero':  this.recebData['numero'],
            'bairro':  this.recebData['bairro'],
            'cep':  this.recebData['cep'],
            'cidade':  this.recebData['cidade'],
            'tel1':  this.recebData['tel1'],
            'estado':  this.recebData['estado'],
            'status': 'A',
            'classe': 'FO'
          }
        }

      }
      this.itensCteData = resData[11]
    },

    selectedFile(){
      this.updating = true
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')
      console.log(typeof dropzoneFile)

      let arquivo = document.querySelector(".dropzoneFile").files[0]
      console.log(arquivo)

      let formData = new FormData();

      formData.append("file", arquivo);

      api.post(`${getBaseUrl()}api/movctefile`,formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        console.log('then axios movctefile')
        console.log(res.data)

        if (res.data[1]) {

          this.traduzirCte(res.data)
          this.updating = false
          this.selecArquivo = false

        } else {
          console.log('documento cte ja foi importado antes')
          this.$router.push('/movcte/editar/' + res.data[0].id)
        }


      }).catch((err) => {
        console.log('erro axios')
        console.log(err)
        // // console.log(err.response)
        // // console.log(err.response.data.errors)
        // let erros = err.response.data.errors
        // console.log(erros)
        // console.log(typeof  erros)
        // let listaErros = []
        // Object.keys(erros).forEach(key => {
        //   console.log(key, erros[key]);
        //   listaErros.push({
        //     'titulo': key,
        //     'mensagem': erros[key]
        //   })
        // });
        // this.errosValid = listaErros
        // this.updating = false
      })

    },

    formSubmit(){
      console.log('formSubmit')
      this.submitted = true;
      this.v$.$touch()
      console.log(this.movCteData)
      console.log(this.enderecosData)

      this.updating = true
      this.errosValid = []
      api.post(`${getBaseUrl()}api/nota`, {
        movCteData: this.movCteData,
        enderData: this.enderecosData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.movCteData = res.data[0]
        this.updating = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
        this.$router.push('/movctesent/list')
      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })


    },


    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    }

  },
  mounted() {
    console.log('mounted_nota_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if (this.$route.query.impobj){
      console.log('this.$route.query')
      console.log(this.$route.query.impobj)
      if (this.$route.query.impobj === 'true'){
        let arraysXml = JSON.parse(localStorage.getItem("impxml"))
        console.log(arraysXml)
        this.traduzirCte(arraysXml)
        this.selecArquivo = false
      }
    }

    if (this.idData > 0){
      api.get(`${getBaseUrl()}api/nota`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.movCteData = res.data[0]
        if (res.data[1]){
          this.enderecosData = res.data[1]
        }
        this.idData = this.movCteData.id
        this.title = `Editar Nota de Entrada (${this.movCteData.id}) ${this.movCteData.nome}`
        this.updating = false
      })
    }else{

      this.updating = false
    }


  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="" >

      <div class="col-lg-12"  v-if="!updating">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">


<!--              <b-button variant="outline-info" class="mx-2" @click="impVarios = !impVarios" v-if="!impVarios">
                <i class="bx bx-box font-size-16 align-middle me-2"></i>
                Múltiplos Arquivos
              </b-button>-->

              <b-button variant="outline-info" class="mx-2" @click="impVarios = !impVarios" v-if="impVarios">
                <i class="bx bx-file font-size-16 align-middle me-2"></i>
                Arquivo Único
              </b-button>

<!--              <b-button variant="outline-primary" class="mx-2" v-if="emitData && emitData.cnpj" @click="showModalEmit = true">-->
<!--                <i class="bx bx-search font-size-16 align-middle me-2"></i>-->
<!--                Cadastro Fornecedor-->
<!--              </b-button>-->


<!--              <b-button variant="outline-info" class="mx-2" >-->
<!--                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>-->
<!--                Copiar-->
<!--              </b-button>-->

<!--              <b-button variant="outline-warning" class="mx-2" v-if="emitData && emitData.cnpj" @click="imporTodosProd">-->
<!--                <i class="bx bx-plus font-size-16 align-middle me-2"></i>-->
<!--                Importar Todos Produtos-->
<!--              </b-button>-->

<!--              <b-button variant="outline-warning" class="mx-2" >-->
<!--                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>-->
<!--                Novo Produto-->
<!--              </b-button>-->


              <!--                    <span-->
              <!--                        class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-22"-->
              <!--                    >-->
              <!--                      <i class="mdi mdi-cash"></i>-->
              <!--                    </span>-->
              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
                  <!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
                  <!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                  <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                </div>
              </div>

              <button v-if="movCteData && movCteData.id > 0"
                      class="btn btn-success" @click="abrirMov">
                <i class="mdi mdi-check-circle me-1 text-end"></i> ABRIR MOVIMENTO DE COMPRA
              </button>


              <button class="btn btn-success" v-if="!movCteData.id && emitData && emitData.cnpj" @click="confirmarImp">
                <i class="mdi mdi-check-circle me-1 text-end"></i> CONFIRMAR IMPORTAÇÃO
              </button>


<!--              <button class="btn btn-danger" @click="confirmarImp">-->
<!--                <i class="mdi mdi-check-circle me-1 text-end"></i> CONFIRMAR IMPORTAÇÃO (DESATIVAR)-->
<!--              </button>-->


            </div>
          </div>
        </div>
      </div>


      <b-card-text v-if="selecArquivo && !updating">
        <div class="card">
          <div class="card-body">
            <div>
              <div class="col-md-12">

                <DropZoneMultiple  @change="selectedFiles" v-if="impVarios" />
                <span class="file-info">Arquivo: </span>



                <DropZone  @change="selectedFile"  v-if="!impVarios"/>
                <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>

              </div>
            </div>
          </div>
        </div>
      </b-card-text>


      <div v-if="!updating && movCteData.codigo">

        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">

                <b-card no-body class="mb-1 shadow-none">
                  <b-card-header header-tag="header" role="tab">
                    <h6 class="m-0">
                      <a
                          v-b-toggle.accordion-1
                          class="text-dark"
                          href="javascript: void(0);"
                      >Dados Principais</a>
                    </h6>
                  </b-card-header>
                  <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
                    <b-card-body>

                      <div class="row mb-2">


                        <div class="col-md-2" >
                          <label for="codigo">Código</label>
                          <div class="position-relative">
                            <input
                                id="codigo"
                                type="text"
                                v-model="movCteData.codigo"
                                class="form-control"
                                :disabled="true"
                                placeholder="Código"/>
                          </div>
                        </div>

                        <div class="col-md-2" >
                          <label for="digito">Dígito</label>
                          <div class="position-relative">
                            <input
                                id="digito"
                                type="text"
                                v-model="movCteData.digito"
                                class="form-control"
                                :disabled="true"
                                placeholder="Dígito"/>
                          </div>
                        </div>

                        <div class="col-md-2" >
                          <label for="cfop">CFOP</label>
                          <div class="position-relative">
                            <input
                                id="cfop"
                                type="text"
                                v-model="movCteData.cfop"
                                class="form-control"
                                :disabled="true"
                                placeholder="CFOP"/>
                          </div>
                        </div>

                        <div class="col-md-4" >
                          <label for="natop">Natureza da Operação</label>
<!--                            <i class="bx bxs-bell-ring font-size-18 bx-fade-right text-danger"></i>-->
                          <div class="position-relative">
                            <input
                                id="natop"
                                type="text"
                                v-model="movCteData.natopv"
                                class="form-control"
                                :disabled="true"
                                placeholder="Natureza da Operação"/>
                          </div>
                        </div>

                        <div class="col-md-2" >
                          <label for="mod">Modalidade</label>
                          <div class="position-relative">
                            <input
                                id="mod"
                                type="text"
                                v-model="movCteData.mod"
                                class="form-control"
                                :disabled="true"
                                placeholder="Modalidade"/>
                          </div>
                        </div>



                      </div>

                      <div class="row mb-2">

<!--                        <div class="col-md-2" >-->
<!--                          <label for="serie">Série</label>-->
<!--                          <div class="position-relative">-->
<!--                            <input-->
<!--                                id="serie"-->
<!--                                type="text"-->
<!--                                v-model="movCteData.serie"-->
<!--                                class="form-control"-->
<!--                                :disabled="true"-->
<!--                                placeholder="Série"/>-->
<!--                          </div>-->
<!--                        </div>-->

                        <div class="col-md-2" >
                          <label for="numero">Número</label>
                          <div class="position-relative">
                            <input
                                id="numero"
                                type="text"
                                v-model="movCteData.numero"
                                class="form-control"
                                :disabled="true"
                                placeholder="Número"/>
                          </div>
                        </div>

                        <div class="col-md-2">
                          <div class="mb-3">
                            <label for="dtemissao">Data de Emissão</label>
                            <input
                                id="dtemissao"
                                v-model="movCteData.dtemissao"
                                type="text"
                                class="form-control"
                                :disabled="true"
                                placeholder="Data de Emissão"/>
                          </div>
                        </div>

                        <div class="col-md-2">
                          <div class="mb-3">
                            <label for="dtpreventr">Previsão de Entrega</label>
                            <input
                                id="dtpreventr"
                                v-model="movCteData.dtpreventr"
                                type="text"
                                class="form-control"
                                :disabled="true"
                                placeholder="Previsão de Entrega"/>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <label for="chave">Chave</label>
                          <div class="position-relative">
                            <input
                                id="chave"
                                type="text"
                                v-model="movCteData.chave"
                                class="form-control"
                                :disabled="true"
                                placeholder="Chave"/>
                          </div>
                        </div>


                      </div>


                      <div class="row mb-3">

                        <div class="col-md-2" >
                          <label for="codmunenv">Cód. Mun. Enviado</label>
                          <div class="position-relative">
                            <input
                                id="codmunenv"
                                type="text"
                                v-model="movCteData.codmunenv"
                                class="form-control"
                                :disabled="true"
                                placeholder="Cód. Mun. Enviado"/>
                          </div>
                        </div>

                        <div class="col-md-4" >
                          <label for="municenv">Município Enviado</label>
                          <div class="position-relative">
                            <input
                                id="municenv"
                                type="text"
                                v-model="movCteData.municenv"
                                class="form-control"
                                :disabled="true"
                                placeholder="Município Enviado"/>
                          </div>
                        </div>

                        <div class="col-md-2" >
                          <label for="ufenv">UF Enviado</label>
                          <div class="position-relative">
                            <input
                                id="ufenv"
                                type="text"
                                v-model="movCteData.ufenv"
                                class="form-control"
                                :disabled="true"
                                placeholder="UF Env."/>
                          </div>
                        </div>

                        <div class="col-md-4" >
                          <label for="carac">Característica Serviço</label>
                          <div class="position-relative">
                            <input
                                id="carac"
                                type="text"
                                v-model="movCteData.carac"
                                class="form-control"
                                :disabled="true"
                                placeholder="Característica Serviço"/>
                          </div>
                        </div>

                      </div>


                      <div class="row mb-3">

                        <div class="col-md-2" >
                          <label for="codmunini">Cód. Mun. Início</label>
                          <div class="position-relative">
                            <input
                                id="codmunini"
                                type="text"
                                v-model="movCteData.codmunini"
                                class="form-control"
                                :disabled="true"
                                placeholder="Cód. Mun. Ini."/>
                          </div>
                        </div>

                        <div class="col-md-4" >
                          <label for="municini">Município Início</label>
                          <div class="position-relative">
                            <input
                                id="municini"
                                type="text"
                                v-model="movCteData.municini"
                                class="form-control"
                                :disabled="true"
                                placeholder="Município Ini."/>
                          </div>
                        </div>

                        <div class="col-md-2" >
                          <label for="ufini">UF Início</label>
                          <div class="position-relative">
                            <input
                                id="ufini"
                                type="text"
                                v-model="movCteData.ufini"
                                class="form-control"
                                :disabled="true"
                                placeholder="UF Início"/>
                          </div>
                        </div>

                      </div>



                      <div class="row">

                        <div class="col-md-2" >
                          <label for="codmunfim">Cód. Mun. Final</label>
                          <div class="position-relative">
                            <input
                                id="codmunfim"
                                type="text"
                                v-model="movCteData.codmunfim"
                                class="form-control"
                                :disabled="true"
                                placeholder="Cód. Mun. Final"/>
                          </div>
                        </div>

                        <div class="col-md-4" >
                          <label for="municfim">Município Final</label>
                          <div class="position-relative">
                            <input
                                id="municfim"
                                type="text"
                                v-model="movCteData.municfim"
                                class="form-control"
                                :disabled="true"
                                placeholder="Município Final"/>
                          </div>
                        </div>

                        <div class="col-md-2" >
                          <label for="uffim">UF Final</label>
                          <div class="position-relative">
                            <input
                                id="uffim"
                                type="text"
                                v-model="movCteData.uffim"
                                class="form-control"
                                :disabled="true"
                                placeholder="UF Final"/>
                          </div>
                        </div>

                      </div>



                    </b-card-body>
                  </b-collapse>
                </b-card>

            </div>
          </div>
        </div>


        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-2
                       class="text-dark"
                       href="javascript: void(0);">
                      Emitente
                    </a>
<!--                    <i class="bx bxs-plus-circle font-size-18 bx-fade-up text-danger" v-if="!emitCompData.id"></i>-->
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-2" visible accordion="my-accordion-2" role="tabpanel">
                  <b-card-body>

                    <div class="row" >
                      <div class="col-md-4"  @click="showModalEmit = true">
                        <label for="destnome">Nome / Razão Social</label>
                        <i v-if="emitCompData && emitData && emitCompData.nome === emitData.nome && emitCompData.id"
                            class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destnome"
                              type="text"
                              v-model="emitData.nome"
                              class="form-control"
                              :disabled="true"
                              placeholder="Nome / Razão Social"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="cnpjemit">CNPJ</label>
                        <i v-if="emitCompData && emitData && emitCompData.cnpj === emitData.cnpj && emitCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="cnpjemit"
                              type="text"
                              v-model="emitData.cnpj"
                              class="form-control"
                              :disabled="true"
                              placeholder="CNPJ"/>
                        </div>



                      </div>

                      <div class="col-md-3" @click="showModalEmit = true">
                        <label for="destinsc">Inscrição Estadual</label>
                        <i v-if="emitCompData && emitData && emitCompData.inscricao === emitData.inscricao && emitCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destinsc"
                              type="text"
                              v-model="emitData.inscricao"
                              class="form-control"
                              :disabled="true"
                              placeholder="Inscrição Estadual"/>
                        </div>
                      </div>



                      <div class="col-md-2" @click="showModalEmit = true">
                        <label for="desttel1">Telefone</label>
                        <i v-if="emitCompData && emitData && emitCompData.tel1 === emitData.tel1 && emitCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="desttel1"
                              type="text"
                              v-model="emitData.tel1"
                              class="form-control"
                              :disabled="true"
                              placeholder="Telefone"/>
                        </div>
                      </div>


                      <div class="col-md-4" @click="showModalEmit = true">
                        <label for="destender">Endereço</label>
                        <i v-if="emitCompData && emitData && emitCompData.rua === emitData.rua && emitCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destender"
                              type="text"
                              v-model="emitData.rua"
                              class="form-control"
                              :disabled="true"
                              placeholder="Endereço"/>
                        </div>
                      </div>


                      <div class="col-md-3" @click="showModalEmit = true">
                        <label for="destnumero">Número</label>
                        <i v-if="emitCompData && emitData && emitCompData.numero === emitData.numero && emitCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destnumero"
                              type="text"
                              v-model="emitData.numero"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-3" @click="showModalEmit = true">
                        <label for="destbairro">Bairro</label>
                        <i v-if="emitCompData && emitData && emitCompData.bairro === emitData.bairro && emitCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destbairro"
                              type="text"
                              v-model="emitData.bairro"
                              class="form-control"
                              :disabled="true"
                              placeholder="Bairro"/>
                        </div>
                      </div>

                      <div class="col-md-2" @click="showModalEmit = true">
                        <label for="destcep">CEP</label>
                        <i v-if="emitCompData && emitData && emitCompData.cep === emitData.cep && emitCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destcep"
                              type="text"
                              v-model="emitData.cep"
                              class="form-control"
                              :disabled="true"
                              placeholder="CEP"/>
                        </div>
                      </div>




                      <div class="col-md-4" @click="showModalEmit = true">
                        <label for="destmunicipio">Município</label>
                        <i v-if="emitCompData && emitData && emitCompData.cidade === emitData.cidade && emitCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destmunicipio"
                              type="text"
                              v-model="emitData.cidade"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município"/>
                        </div>
                      </div>

                      <div class="col-md-3" @click="showModalEmit = true">
                        <label for="destestado">UF</label>
                        <i v-if="emitCompData && emitData && emitCompData.estado === emitData.estado && emitCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destestado"
                              type="text"
                              v-model="emitData.estado"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF"/>
                        </div>
                      </div>


                    </div>




                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>



        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-21
                       class="text-dark"
                       href="javascript: void(0);">
                      Remetente
                    </a>
<!--                    <i class="bx bxs-plus-circle font-size-18 bx-fade-up text-danger" v-if="!remetCompData.id"></i>-->
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-21" visible accordion="my-accordion-21" role="tabpanel">
                  <b-card-body>

                    <div class="row" >
                      <div class="col-md-4"  @click="showModalRemet = true">
                        <label for="destnome">Nome / Razão Social</label>
                        <i v-if="remetCompData && remetData && remetCompData.nome === remetData.nome && remetCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destnome"
                              type="text"
                              v-model="remetData.nome"
                              class="form-control"
                              :disabled="true"
                              placeholder="Nome / Razão Social"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="cnpjemit">CNPJ</label>
                        <i v-if="remetCompData && remetData && remetCompData.cnpj === remetData.cnpj && remetCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="cnpjemit"
                              type="text"
                              v-model="remetData.cnpj"
                              class="form-control"
                              :disabled="true"
                              placeholder="CNPJ"/>
                        </div>



                      </div>

                      <div class="col-md-3" @click="showModalRemet = true">
                        <label for="destinsc">Inscrição Estadual</label>
                        <i v-if="remetCompData && remetData && remetCompData.inscricao === remetData.inscricao && remetCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destinsc"
                              type="text"
                              v-model="remetData.inscricao"
                              class="form-control"
                              :disabled="true"
                              placeholder="Inscrição Estadual"/>
                        </div>
                      </div>



                      <div class="col-md-2" @click="showModalRemet = true">
                        <label for="desttel1">Telefone</label>
                        <i v-if="remetCompData && remetData && remetCompData.tel1 === remetData.tel1 && remetCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="desttel1"
                              type="text"
                              v-model="remetData.tel1"
                              class="form-control"
                              :disabled="true"
                              placeholder="Telefone"/>
                        </div>
                      </div>


                      <div class="col-md-4" @click="showModalRemet = true">
                        <label for="destender">Endereço</label>
                        <i v-if="remetCompData && remetData && remetCompData.rua === remetData.rua && remetCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destender"
                              type="text"
                              v-model="remetData.rua"
                              class="form-control"
                              :disabled="true"
                              placeholder="Endereço"/>
                        </div>
                      </div>


                      <div class="col-md-3" @click="showModalRemet = true">
                        <label for="destnumero">Número</label>
                        <i v-if="remetCompData && remetData && remetCompData.numero === remetData.numero && remetCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destnumero"
                              type="text"
                              v-model="remetData.numero"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-3" @click="showModalRemet = true">
                        <label for="destbairro">Bairro</label>
                        <i v-if="remetCompData && remetData && remetCompData.bairro === remetData.bairro && remetCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destbairro"
                              type="text"
                              v-model="remetData.bairro"
                              class="form-control"
                              :disabled="true"
                              placeholder="Bairro"/>
                        </div>
                      </div>

                      <div class="col-md-2" @click="showModalRemet = true">
                        <label for="destcep">CEP</label>
                        <i v-if="remetCompData && remetData && remetCompData.cep === remetData.cep && remetCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destcep"
                              type="text"
                              v-model="remetData.cep"
                              class="form-control"
                              :disabled="true"
                              placeholder="CEP"/>
                        </div>
                      </div>




                      <div class="col-md-4" @click="showModalRemet = true">
                        <label for="destmunicipio">Município</label>
                        <i v-if="remetCompData && remetData && remetCompData.cidade === remetData.cidade && remetCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destmunicipio"
                              type="text"
                              v-model="remetData.cidade"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município"/>
                        </div>
                      </div>

                      <div class="col-md-3" @click="showModalRemet = true">
                        <label for="remetestado">UF</label>
                        <i v-if="remetCompData && remetData && remetCompData.estado === remetData.estado && emitCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="remetestado"
                              type="text"
                              v-model="remetData.estado"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF"/>
                        </div>
                      </div>

                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>


        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-22
                       class="text-dark"
                       href="javascript: void(0);">
                      Expedição
                    </a>
<!--                    <i class="bx bxs-plus-circle font-size-18 bx-fade-up text-danger" v-if="!expedCompData.id"></i>-->
                  </h6>
                </b-card-header>
                <b-collapse v-if="expedData"
                            id="accordion-22"
                            visible accordion="my-accordion-22"
                            role="tabpanel">
                  <b-card-body>

                    <div class="row" >
                      <div class="col-md-4"  @click="showModalExped = true">
                        <label for="destnome">Nome / Razão Social</label>
                        <i v-if="expedCompData && expedData && expedCompData.nome === expedData.nome && expedCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destnome"
                              type="text"
                              v-model="expedData.nome"
                              class="form-control"
                              :disabled="true"
                              placeholder="Nome / Razão Social"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="cnpjemit">CNPJ</label>
                        <i v-if="expedCompData && expedData && expedCompData.cnpj === expedData.cnpj && expedCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="cnpjemit"
                              type="text"
                              v-model="expedData.cnpj"
                              class="form-control"
                              :disabled="true"
                              placeholder="CNPJ"/>
                        </div>

                      </div>

                      <div class="col-md-3" @click="showModalExped = true">
                        <label for="destinsc">Inscrição Estadual</label>
                        <i v-if="expedCompData && expedData && expedCompData.inscricao === expedData.inscricao && expedCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destinsc"
                              type="text"
                              v-model="expedData.inscricao"
                              class="form-control"
                              :disabled="true"
                              placeholder="Inscrição Estadual"/>
                        </div>
                      </div>



                      <div class="col-md-2" @click="showModalExped = true">
                        <label for="desttel1">Telefone</label>
                        <i v-if="expedCompData && expedData && expedCompData.tel1 === expedData.tel1 && expedCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="desttel1"
                              type="text"
                              v-model="expedData.tel1"
                              class="form-control"
                              :disabled="true"
                              placeholder="Telefone"/>
                        </div>
                      </div>




                      <div class="col-md-4" @click="showModalExped = true">
                        <label for="destender">Endereço</label>
                        <i v-if="expedCompData && expedData && expedCompData.rua === expedData.rua && expedCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destender"
                              type="text"
                              v-model="expedData.rua"
                              class="form-control"
                              :disabled="true"
                              placeholder="Endereço"/>
                        </div>
                      </div>


                      <div class="col-md-3" @click="showModalExped = true">
                        <label for="destnumero">Número</label>
                        <i v-if="expedCompData && expedData && expedCompData.numero === expedData.numero && expedCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destnumero"
                              type="text"
                              v-model="expedData.numero"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-3" @click="showModalExped = true">
                        <label for="destbairro">Bairro</label>
                        <i v-if="expedCompData && expedData && expedCompData.bairro === expedData.bairro && expedCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destbairro"
                              type="text"
                              v-model="expedData.bairro"
                              class="form-control"
                              :disabled="true"
                              placeholder="Bairro"/>
                        </div>
                      </div>

                      <div class="col-md-2" @click="showModalExped = true">
                        <label for="destcep">CEP</label>
                        <i v-if="expedCompData && expedData && expedCompData.cep === expedData.cep && expedCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destcep"
                              type="text"
                              v-model="expedData.cep"
                              class="form-control"
                              :disabled="true"
                              placeholder="CEP"/>
                        </div>
                      </div>



                      <div class="col-md-4" @click="showModalExped = true">
                        <label for="expedmunicipio">Município</label>
                        <i v-if="expedCompData && expedData && expedCompData.cidade === expedData.cidade && expedCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="expedmunicipio"
                              type="text"
                              v-model="expedData.cidade"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município"/>
                        </div>
                      </div>


                      <div class="col-md-3" @click="showModalExped = true">
                        <label for="expedestado">UF</label>
                        <i v-if="expedCompData && expedData && expedCompData.estado === expedData.estado && emitCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="expedestado"
                              type="text"
                              v-model="expedData.estado"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF"/>
                        </div>
                      </div>

                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>




        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-23
                       class="text-dark"
                       href="javascript: void(0);">
                      Recebedor
                    </a>
<!--                    <i class="bx bxs-plus-circle font-size-18 bx-fade-up text-danger" v-if="!recebCompData.id"></i>-->
                  </h6>
                </b-card-header>
                <b-collapse v-if="recebData"
                            id="accordion-23"
                            visible accordion="my-accordion-23" role="tabpanel">
                  <b-card-body>

                    <div class="row" >
                      <div class="col-md-4"  @click="showModalReceb = true">
                        <label for="destnome">Nome / Razão Social</label>
                        <i v-if="recebCompData && recebData && recebCompData.nome === recebData.nome && recebCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destnome"
                              type="text"
                              v-model="recebData.nome"
                              class="form-control"
                              :disabled="true"
                              placeholder="Nome / Razão Social"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="cnpjemit">CNPJ</label>
                        <i v-if="recebCompData && recebData && recebCompData.cnpj === recebData.cnpj && recebCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="cnpjemit"
                              type="text"
                              v-model="recebData.cnpj"
                              class="form-control"
                              :disabled="true"
                              placeholder="CNPJ"/>
                        </div>



                      </div>

                      <div class="col-md-3" @click="showModalReceb = true">
                        <label for="destinsc">Inscrição Estadual</label>
                        <i v-if="recebCompData && recebData && recebCompData.inscricao === recebData.inscricao && recebCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destinsc"
                              type="text"
                              v-model="recebData.inscricao"
                              class="form-control"
                              :disabled="true"
                              placeholder="Inscrição Estadual"/>
                        </div>
                      </div>



                      <div class="col-md-2" @click="showModalReceb = true">
                        <label for="desttel1">Telefone</label>
                        <i v-if="recebCompData && recebData && recebCompData.tel1 === recebData.tel1 && recebCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="desttel1"
                              type="text"
                              v-model="recebData.tel1"
                              class="form-control"
                              :disabled="true"
                              placeholder="Telefone"/>
                        </div>
                      </div>

                      <div class="col-md-4" @click="showModalReceb = true">
                        <label for="destender">Endereço</label>
                        <i v-if="recebCompData && recebData && recebCompData.rua === recebData.rua && recebCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destender"
                              type="text"
                              v-model="recebData.rua"
                              class="form-control"
                              :disabled="true"
                              placeholder="Endereço"/>
                        </div>
                      </div>


                      <div class="col-md-3" @click="showModalReceb = true">
                        <label for="destnumero">Número</label>
                        <i v-if="recebCompData && recebData && recebCompData.numero === recebData.numero && recebCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destnumero"
                              type="text"
                              v-model="recebData.numero"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-3" @click="showModalReceb = true">
                        <label for="destbairro">Bairro</label>
                        <i v-if="recebCompData && recebData && recebCompData.bairro === recebData.bairro && recebCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destbairro"
                              type="text"
                              v-model="recebData.bairro"
                              class="form-control"
                              :disabled="true"
                              placeholder="Bairro"/>
                        </div>
                      </div>

                      <div class="col-md-2" @click="showModalReceb = true">
                        <label for="destcep">CEP</label>
                        <i v-if="recebCompData && recebData && recebCompData.cep === recebData.cep && recebCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destcep"
                              type="text"
                              v-model="recebData.cep"
                              class="form-control"
                              :disabled="true"
                              placeholder="CEP"/>
                        </div>
                      </div>



                      <div class="col-md-4" @click="showModalReceb = true">
                        <label for="recebmunicipio">Município</label>
                        <i v-if="recebCompData && recebData && recebCompData.cidade === recebData.cidade && recebCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="recebmunicipio"
                              type="text"
                              v-model="recebData.cidade"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município"/>
                        </div>
                      </div>

                      <div class="col-md-3" @click="showModalReceb = true">
                        <label for="recebestado">UF</label>
                        <i v-if="recebCompData && recebData && recebCompData.estado === recebData.estado && recebCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="recebestado"
                              type="text"
                              v-model="recebData.estado"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF"/>
                        </div>
                      </div>


                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>



        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-24
                       class="text-dark"
                       href="javascript: void(0);">
                      Destinatário
                    </a>
<!--                    <i class="bx bxs-plus-circle font-size-18 bx-fade-up text-danger" v-if="!recebCompData.id"></i>-->
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-24" visible accordion="my-accordion-24" role="tabpanel">
                  <b-card-body>

                    <div class="row" >
                      <div class="col-md-4"  @click="showModalDest = true">
                        <label for="destnome">Nome / Razão Social</label>
                        <i v-if="destCompData && destData && destCompData.nome === destData.nome && destCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destnome"
                              type="text"
                              v-model="destData.nome"
                              class="form-control"
                              :disabled="true"
                              placeholder="Nome / Razão Social"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="cnpjemit">CNPJ</label>
                        <i v-if="destCompData && destData && destCompData.cnpj === destData.cnpj && destCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="cnpjemit"
                              type="text"
                              v-model="destData.cnpj"
                              class="form-control"
                              :disabled="true"
                              placeholder="CNPJ"/>
                        </div>



                      </div>

                      <div class="col-md-3" @click="showModalDest = true">
                        <label for="destinsc">Inscrição Estadual</label>
                        <i v-if="destCompData && destData && destCompData.inscricao === destData.inscricao && destCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destinsc"
                              type="text"
                              v-model="destData.inscricao"
                              class="form-control"
                              :disabled="true"
                              placeholder="Inscrição Estadual"/>
                        </div>
                      </div>



                      <div class="col-md-2" @click="showModalDest = true">
                        <label for="desttel1">Telefone</label>
                        <i v-if="destCompData && destData && destCompData.tel1 === destData.tel1 && destCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="desttel1"
                              type="text"
                              v-model="destData.tel1"
                              class="form-control"
                              :disabled="true"
                              placeholder="Telefone"/>
                        </div>
                      </div>

                      <div class="col-md-4" @click="showModalDest = true">
                        <label for="destender">Endereço</label>
                        <i v-if="destCompData && destData && destCompData.rua === destData.rua && destCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destender"
                              type="text"
                              v-model="destData.rua"
                              class="form-control"
                              :disabled="true"
                              placeholder="Endereço"/>
                        </div>
                      </div>


                      <div class="col-md-3" @click="showModalDest = true">
                        <label for="destnumero">Número</label>
                        <i v-if="destCompData && destData && destCompData.numero === destData.numero && destCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destnumero"
                              type="text"
                              v-model="destData.numero"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-3" @click="showModalDest = true">
                        <label for="destbairro">Bairro</label>
                        <i v-if="destCompData && destData && destCompData.bairro === destData.bairro && destCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destbairro"
                              type="text"
                              v-model="destData.bairro"
                              class="form-control"
                              :disabled="true"
                              placeholder="Bairro"/>
                        </div>
                      </div>

                      <div class="col-md-2" @click="showModalDest = true">
                        <label for="destcep">CEP</label>
                        <i v-if="destCompData && destData && destCompData.cep === destData.cep && destCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destcep"
                              type="text"
                              v-model="destData.cep"
                              class="form-control"
                              :disabled="true"
                              placeholder="CEP"/>
                        </div>
                      </div>


                      <div class="col-md-4" @click="showModalDest = true">
                        <label for="destmunicipio">Município</label>
                        <i v-if="destCompData && destData && destCompData.cidade === destData.cidade && destCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destmunicipio"
                              type="text"
                              v-model="destData.cidade"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município"/>
                        </div>
                      </div>


                      <div class="col-md-3" @click="showModalDest = true">
                        <label for="destestado">UF</label>
                        <i v-if="destCompData && destData && destCompData.estado === destData.estado && destCompData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destestado"
                              type="text"
                              v-model="destData.estado"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF"/>
                        </div>
                      </div>




                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>




        <b-card-text>
          <div class="card">
            <div class="card-body">


              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">

                  <li class="list-inline-item">
                    <h6 class="m-0">
                      <a
                          v-b-toggle.accordion-4
                          class="text-dark"
                          href="javascript: void(0);"
                      >Valores e Impostos</a>
                    </h6>
                  </li>


                </b-card-header>

                <b-collapse id="accordion-4" visible accordion="my-accordion-4" role="tabpanel">
                  <b-card-body>


                    <div class="row mb-2">

                      <div class="col-md-3 text-end">
                        <label for="bcicms">CST ICMS</label>
                        <div class="position-relative">
                          <input
                              id="bcicms"
                              type="text"
                              v-model="movCteData.icmscst"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="CST ICMS"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="bcicmsst">Base ICMS</label>
                        <div class="position-relative">
                          <input
                              id="icmsvbc"
                              type="number"
                              v-model="movCteData.icmsvbc"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Base de cálculo do ICMS"/>
                        </div>
                      </div>



                      <div class="col-md-2 text-end">
                        <label for="vlricmsst">Alíquota ICMS</label>
                        <div class="position-relative">
                          <input
                              id="icmsaliq"
                              type="number"
                              v-model="movCteData.icmsaliq"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Alíquota ICMS"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="icmsvalor">Valor ICMS</label>
                        <div class="position-relative">
                          <input
                              id="icmsvalor"
                              type="number"
                              v-model="movCteData.icmsvalor"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor do ICMS"/>
                        </div>
                      </div>

                      <div class="col-md-3 text-end">
                        <label for="totaltrib">Valor total tributado</label>
                        <div class="position-relative">
                          <input
                              id="totaltrib"
                              type="number"
                              v-model="movCteData.totaltrib"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor total tributado"/>
                        </div>
                      </div>


                    </div>

                    <div class="row mb-2">

                      <div class="col-md-3 text-end">
                        <label for="valorcarga">Valor Carga</label>
                        <div class="position-relative">
                          <input
                              id="valorcarga"
                              type="number"
                              v-model="movCteData.valorcarga"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor Carga"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="valor">Valor Total do Frete</label>
                        <div class="position-relative">
                          <input
                              id="valor"
                              type="number"
                              v-model="movCteData.valor"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor Total do Frete"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="valorfrete">Valor do frete</label>
                        <div class="position-relative">
                          <input
                              id="valorfrete"
                              type="text"
                              v-model="movCteData.valorfrete"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor do frete"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="gris">GRIS</label>
                        <div class="position-relative">
                          <input
                              id="gris"
                              type="number"
                              v-model="movCteData.gris"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="GRIS"/>
                        </div>
                      </div>

                      <div class="col-md-3 text-end">
                        <label for="imprep">Imposto Rep.</label>
                        <div class="position-relative">
                          <input
                              id="imprep"
                              type="number"
                              v-model="movCteData.imprep"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Imposto Repassado"/>
                        </div>
                      </div>

                      <div class="col-md-3 text-end">
                        <label for="cubagem">Cubagem</label>
                        <div class="position-relative">
                          <input
                              id="cubagem"
                              type="number"
                              v-model="movCteData.cubagem"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Cubagem"/>
                        </div>
                      </div>

                    </div>

                    <div class="row mb-2">
                      <div class="col-md-3 text-end">
                        <label for="pedagio">Pedágio</label>
                        <div class="position-relative">
                          <input
                              id="pedagio"
                              type="number"
                              v-model="movCteData.pedagio"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Pedágio"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="unimed">Un. Medida</label>
                        <div class="position-relative">
                          <input
                              id="unimed"
                              type="text"
                              v-model="movCteData.unimed"
                              class="form-control"
                              :disabled="true"
                              placeholder="Un. Medida"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="qtdund">Qtd.Un.</label>
                        <div class="position-relative">
                          <input
                              id="qtdund"
                              type="number"
                              v-model="movCteData.qtdund"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Qtd.Un."/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="cubdesc">Cubagem Desc.</label>
                        <div class="position-relative">
                          <input
                              id="cubdesc"
                              type="text"
                              v-model="movCteData.cubdesc"
                              class="form-control"
                              :disabled="true"
                              placeholder="Cubagem Desc."/>
                        </div>
                      </div>

                      <div class="col-md-3 text-end">
                        <label for="volumes">Volumes</label>
                        <div class="position-relative">
                          <input
                              id="volumes"
                              type="number"
                              v-model="movCteData.volumes"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Volumes"/>
                        </div>
                      </div>

                    </div>

                    <div class="row mb-2">

                      <div class="col-md-3 text-end">
                        <label for="peso">Peso</label>
                        <div class="position-relative">
                          <input
                              id="peso"
                              type="number"
                              v-model="movCteData.peso"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso"/>
                        </div>
                      </div>


                      <div class="col-md-2 text-end">
                        <label for="pesocub">Peso Cubagem</label>
                        <div class="position-relative">
                          <input
                              id="pesocub"
                              type="number"
                              v-model="movCteData.pesocub"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Cubagem"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="pesoafer">Peso Aferido</label>
                        <div class="position-relative">
                          <input
                              id="pesoafer"
                              type="number"
                              v-model="movCteData.pesoafer"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Aferido"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="pesovbc">Peso Base Cãlculo</label>
                        <div class="position-relative">
                          <input
                              id="pesovbc"
                              type="number"
                              v-model="movCteData.pesovbc"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Base Cãlculo"/>
                        </div>
                      </div>

                      <div class="col-md-3 text-end">
                        <label for="pesobrt">Peso Bruto</label>
                        <div class="position-relative">
                          <input
                              id="pesobrt"
                              type="number"
                              v-model="movCteData.pesobrt"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Bruto"/>
                        </div>
                      </div>


                    </div>


                    <div class="row mb-2">

                      <div class="col-md-3 text-end">
                        <label for="pesodecl">Peso Declarado</label>
                        <div class="position-relative">
                          <input
                              id="pesodecl"
                              type="number"
                              v-model="movCteData.pesodecl"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Declarado"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="pesoinfo">Peso Informado</label>
                        <div class="position-relative">
                          <input
                              id="pesoinfo"
                              type="number"
                              v-model="movCteData.pesoinfo"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Informado"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="pesoreal">Peso Real</label>
                        <div class="position-relative">
                          <input
                              id="pesoreal"
                              type="number"
                              v-model="movCteData.pesoreal"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Real"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="pesotaxa">Peso Taxa</label>
                        <div class="position-relative">
                          <input
                              id="pesotaxa"
                              type="number"
                              v-model="movCteData.pesotaxa"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Taxa"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="pesofrete">Peso Frete</label>
                        <div class="position-relative">
                          <input
                              id="pesofrete"
                              type="number"
                              v-model="movCteData.pesofrete"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Frete"/>
                        </div>
                      </div>




                    </div>



                    <div class="row mb-2">


                      <div class="col-md-9">
                        <label for="prodpredom">Produto Predominante</label>
                        <div class="position-relative">
                          <input
                              id="prodpredom"
                              type="text"
                              v-model="movCteData.prodpredom"
                              class="form-control"
                              :disabled="true"
                              placeholder="Produto Predominante"/>
                        </div>
                      </div>

                    </div>

                    <div class="row mt-5">
                      <div class="col-md-9 text-end">
                      </div>

<!--                      <div class="col-md-3 text-end">-->
<!--                        <b-button variant="outline-info" class="mx-2" @click="selecArquivo = !selecArquivo">-->
<!--                          <i class="bx bx-search-alt font-size-16 align-middle me-2"></i>-->
<!--                          Conferência de Cálculo-->
<!--                        </b-button>-->
<!--                      </div>-->


                    </div>


                  </b-card-body>
                </b-collapse>
              </b-card>



            </div>
          </div>

        </b-card-text>



        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-6
                        class="text-dark"
                        href="javascript: void(0);"
                    >Notas Fiscais</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-6" visible accordion="my-accordion-6" role="tabpanel">
                  <b-card-body>

                    <div class="row">


                      <div class="table-responsive">
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>

                            <th scope="col">Chave</th>

                          </tr>
                          </thead>
                          <tbody>

                          <tr v-for="item in itensCteData" :key="item.chave">

                            <td class="text-muted mb-0">{{ item.chave }}</td>


                          </tr>

                          </tbody>
                        </table>
                      </div>


                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>







        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-8
                        class="text-dark"
                        href="javascript: void(0);"
                    >Dados Adicionais</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-8" visible accordion="my-accordion-8" role="tabpanel">
                  <b-card-body>

                    <div class="row mb-2">
                      <div class="col-md-12">
                        <label for="inscrmun">Observações</label>
                        <div class="position-relative">
                        <textarea
                            id="inscrmun"
                            type="text"
                            rows="4"
                            v-model="movCteData.obs"
                            class="form-control"
                            :disabled="true"
                            placeholder="Observações"/>
                        </div>
                      </div>
                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>


            </div>
          </div>

        </b-card-text>

      </div>

    </div>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>


    <b-modal title="Detalhes Tipo de Operação" v-model="showModalPedTipo" centered hide-footer v-if="movCteData">
      <div class="col-md-12">
        <div class="mb-3">
          <label for="notatipo">Tipo de Operação definida para este CFOP</label>
          <div >
            <router-link :to="`/tiposopera/list`" target="_blank" >
              <p class="mb-2">
                Código:
                <span class="text-primary"> {{ pedTipoData.codigo }} </span>
              </p>
              <p class="mb-2" >
                Descrição:
                <span class="text-primary">  {{ pedTipoData.descricao }}  </span>
              </p>
            </router-link>
          </div>
          <multiselect id="notatipo"
                       @search-change="pesqPedTipo"
                       @select="escolheuPedTipo"
                       v-model="movCteData.tipo"
                       placeholder="Pesquisar novo tipo de operação"
                       :options="dtlistPesqPedTipo"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingPedTipo">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div >
        <p class="mb-2 mt-5">
          Parâmetros
        </p>
        <div class="row">
        <div class="col-md-6">
          <span class="text-primary">Efetivar Estoque </span>
          <b-form-checkbox
              switch size="lg"
              value="A"
              unchecked-value="I"
              v-model="pedTipoData.afestoque">
            {{ pedTipoData.afestoque === 'A' ? 'Sim' : 'Não' }}
          </b-form-checkbox>
        </div>
        <div class="col-md-6">
          <span class="text-primary">Conciliar Financeiro </span>
          <b-form-checkbox
              switch size="lg"
              value="A"
              unchecked-value="I"
              v-model="pedTipoData.affinanc">
            {{ pedTipoData.affinanc === 'A' ? 'Sim' : 'Não' }}
          </b-form-checkbox>
        </div>
        </div>
        <p class="mb-5" >
          ESTOQUE:
          <span class="text-primary"> Todos os representantes serão notificados  </span>
        </p>
        <div class="table-responsive" >
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos deste Fornecedor</th>
              <th scope="col">CFOP</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
<!--            <tr v-for="data in ultPedsData" :key="data.id">-->
<!--              <td>-->
<!--                <router-link :to="`/movcte/editar/${data.id}`" target="_blank">-->
<!--                  <div>-->
<!--                    <h5 class="text-truncate font-size-14">-->
<!--                      {{ data.codigo }}-->
<!--                    </h5>-->
<!--                  </div>-->
<!--                </router-link>-->
<!--              </td>-->
<!--              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>-->
<!--              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td colspan="2">-->
<!--                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>-->
<!--              </td>-->
<!--              <td class="text-end">R$ {{ formatDecimal(somaPedidosCli) }}</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td colspan="2">-->
<!--                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>-->
<!--              </td>-->
<!--              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosCli / 3) }}</td>-->
<!--            </tr>-->
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPedTipo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalPedTipo = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>





    <b-modal size="xl"
             :title="emitCompData && emitCompData.id > 0 ? `Detalhes Emitente ${emitCompData.cnpj}` : `Detalhes Novo Emitente`"
             v-model="showModalEmit"
             centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">

          <div v-if="emitCompData && emitCompData.id > 0"
              class="mb-5">
            <span>Emitente encontrado com este CNPJ</span>
            <router-link :to="`/cliente/editar/${emitCompData.id}`" target="_blank" >
              <p class="mb-2">
                Código:
                <span class="text-primary"> {{ emitCompData.codigo }} </span>
              </p>
            </router-link>
          </div>

          <div v-else
               class="mb-5">
            <span>Um Novo Emitente será cadastrado com este CNPJ</span>

          </div>


<!--

                       <div class="col-md-3">

                        <label for="cnpjemit">CNPJ</label>
                        <div class="position-relative">
                          <input
                              id="cnpjemit"
                              type="text"
                              v-model="emitData.cnpj"
                              class="form-control"
                              :disabled="true"
                              placeholder="CNPJ"/>

                          <div class="chat-input-links" v-if="emitData.cnpj">
                            <ul class="list-inline mb-0">
                              <li class="list-inline-item">
                                <a
                                    href="javascript: void(0);"
                                    v-b-tooltip.hover
                                    placement="top"
                                    title="Consultar CNPJ Dados Públicos">
                                  <i class="mdi mdi-database-search"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>



                      </div>
-->

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="nomex">Razão XML</label>
                  <div class="position-relative">
                    <input
                        id="nomex"
                        v-model="emitData.nome"
                        type="text"
                        class="form-control"
                        :disabled="true"
                        placeholder="Nome"/>
                    <div class="chat-input-links" v-if="emitData.nome">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                          <a
                              href="javascript: void(0);"
                              v-b-tooltip.hover
                              placement="top"
                              @click="emitCompData.nome = emitData.nome"
                              title="Importar informação de XML">
                            <i class="mdi mdi-import"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="nomec">Razão Cadastro</label>
                <i v-if="emitCompData && emitData && emitCompData.nome !== emitData.nome"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="nomec"
                    v-model="emitCompData.nome"
                    type="text"
                    class="form-control"
                    placeholder="Razão Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="fantasiax">Nome Fantasia XML</label>
                <div class="position-relative">
                  <input
                      id="fantasiax"
                      v-model="emitData.nome"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Nome Fantasia XML"/>
                  <div class="chat-input-links" v-if="emitData.nome">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="emitCompData.nome = emitData.nome"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="fantasiac">Nome Fantasia Cadastro</label>
                <i v-if="emitCompData && emitData && emitCompData.nome !== emitData.nome"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="fantasiac"
                    v-model="emitCompData.fantasia"
                    type="text"
                    class="form-control"
                    placeholder="Nome Fantasia Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="ruax">Endereço XML</label>
                <div class="position-relative">
                  <input
                      id="ruax"
                      v-model="emitData.rua"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Endereço XML"/>
                  <div class="chat-input-links" v-if="emitData.rua">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="emitCompData.rua = emitData.rua"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="ruac">Endereço Cadastro</label>
                <i v-if="emitCompData && emitData && emitCompData.rua !== emitData.rua"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="ruac"
                    v-model="emitCompData.rua"
                    type="text"
                    class="form-control"
                    placeholder="Endereço Cadastro"/>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="inscricaox">Inscrição Estadual XML</label>
                <div class="position-relative">
                  <input
                      id="inscricaox"
                      v-model="emitData.inscricao"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Inscrição Estadual XML"/>
                  <div class="chat-input-links" v-if="emitData.inscricao">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="emitCompData.inscricao = emitData.inscricao"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="inscricaoc">Inscrição Estadual Cadastro</label>
                <i v-if="emitCompData && emitData && emitCompData.inscricao !== emitData.inscricao"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="inscricaoc"
                    v-model="emitCompData.inscricao"
                    type="text"
                    class="form-control"
                    placeholder="Inscrição Estadual Cadastro"/>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="numerox">Número XML</label>
                <div class="position-relative">
                  <input
                      id="numerox"
                      v-model="emitData.numero"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Número XML"/>
                  <div class="chat-input-links" v-if="emitData.numero">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="emitCompData.numero = emitData.numero"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="numeroc">Número Cadastro</label>
                <i v-if="emitCompData && emitData && emitCompData.numero !== emitData.numero"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="numeroc"
                    v-model="emitCompData.numero"
                    type="text"
                    class="form-control"
                    placeholder="Número Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="cepx">CEP XML</label>
                <div class="position-relative">
                  <input
                      id="cepx"
                      v-model="emitData.cep"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="CEP XML"/>
                  <div class="chat-input-links" v-if="emitData.cep">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="emitCompData.cep = emitData.cep"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="cepc">CEP Cadastro</label>
                <i v-if="emitCompData && emitData && emitCompData.cep !== emitData.cep"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="cepc"
                    v-maska="'##.###-###'"
                    v-model="emitCompData.cep"
                    type="text"
                    class="form-control"
                    placeholder="CEP Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="bairrox">Bairro XML</label>
                <div class="position-relative">
                  <input
                      id="bairrox"
                      v-model="emitData.bairro"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Bairro XML"/>
                  <div class="chat-input-links" v-if="emitData.bairro">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="emitCompData.bairro = emitData.bairro"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="bairroc">Bairro Cadastro</label>
                <i v-if="emitCompData && emitData && emitCompData.bairro !== emitData.bairro"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="bairroc"
                    v-model="emitCompData.bairro"
                    type="text"
                    class="form-control"
                    placeholder="Bairro Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="tel1x">Telefone XML</label>
                <div class="position-relative">
                  <input
                      id="tel1x"
                      v-model="emitData.tel1"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Telefone XML"/>
                  <div class="chat-input-links" v-if="emitData.tel1">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="emitCompData.tel1 = emitData.tel1"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="tel1c">Telefone Cadastro</label>
                <i v-if="emitCompData && emitData && emitCompData.tel1 !== emitData.tel1"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="tel1c"
                    v-maska="'##.#####-####'"
                    v-model="emitCompData.tel1"
                    type="text"
                    class="form-control"
                    placeholder="Telefone Cadastro"/>
              </div>
            </div>
          </div>




          <div class="row">
            <div class="col-md-4">
              <div class="mb-3">
                <label for="municipio">Município</label>
                <input
                    id="municipio"
                    v-model="emitCompData.cidade"
                    type="text"
                    class="form-control"
                    :disabled="true"
                    placeholder="Município"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3">
                <label for="codmun">Código Município</label>
                <input
                    id="codmun"
                    v-model="emitCompData.codmun"
                    type="text"
                    class="form-control"
                    :disabled="true"
                    placeholder="Código Município"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3 text-end">
                <label for="estado">Estado</label>
                <input
                    id="estado"
                    v-model="emitCompData.estado"
                    type="text"
                    class="form-control text-end"
                    :disabled="true"
                    placeholder="Estado"/>
              </div>
            </div>
          </div>


        </div>
      </div>


      <div >
<!--        <p class="mb-2 mt-5">-->
<!--          Parâmetros-->
<!--        </p>-->
        <div class="row">
          <div class="col-md-6">
            <span class="text-primary">Status Fornecedor </span>
            <b-form-checkbox
                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="emitCompData.status">
              {{ emitCompData.status === 'A' ? 'Ativo' : 'Inativo' }}
            </b-form-checkbox>
          </div>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalEmit = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confEmit">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            {{ textConfAlteracoesFornec }}
          </b-button>


        </div>
      </div>
    </b-modal>



    <b-modal size="xl"
             :title="remetCompData && remetCompData.id > 0 ? `Detalhes Remetente ${remetCompData.cnpj}` : `Detalhes Novo Remetente`"
             v-model="showModalRemet"
             centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">

          <div v-if="remetCompData && remetCompData.id > 0"
               class="mb-5">
            <span>Remetente encontrado com este CNPJ</span>
            <router-link :to="`/cliente/editar/${remetCompData.id}`" target="_blank" >
              <p class="mb-2">
                Código:
                <span class="text-primary"> {{ remetCompData.codigo }} </span>
              </p>
            </router-link>
          </div>

          <div v-else
               class="mb-5">
            <span>Um Novo Remetente será cadastrado com este CNPJ</span>

          </div>


          <!--

                                 <div class="col-md-3">

                                  <label for="cnpjemit">CNPJ</label>
                                  <div class="position-relative">
                                    <input
                                        id="cnpjemit"
                                        type="text"
                                        v-model="emitData.cnpj"
                                        class="form-control"
                                        :disabled="true"
                                        placeholder="CNPJ"/>

                                    <div class="chat-input-links" v-if="emitData.cnpj">
                                      <ul class="list-inline mb-0">
                                        <li class="list-inline-item">
                                          <a
                                              href="javascript: void(0);"
                                              v-b-tooltip.hover
                                              placement="top"
                                              title="Consultar CNPJ Dados Públicos">
                                            <i class="mdi mdi-database-search"></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>



                                </div>
          -->

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="nomex">Razão XML</label>
                <div class="position-relative">
                  <input
                      id="nomex"
                      v-model="remetData.nome"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Nome"/>
                  <div class="chat-input-links" v-if="remetData.nome">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="remetCompData.nome = remetData.nome"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="nomec">Razão Cadastro</label>
                <i v-if="remetCompData && remetData && remetCompData.nome !== remetData.nome"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="nomec"
                    v-model="remetCompData.nome"
                    type="text"
                    class="form-control"
                    placeholder="Razão Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="fantasiax">Nome Fantasia XML</label>
                <div class="position-relative">
                  <input
                      id="fantasiax"
                      v-model="remetData.nome"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Nome Fantasia XML"/>
                  <div class="chat-input-links" v-if="remetData.nome">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="remetCompData.nome = remetData.nome"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="fantasiac">Nome Fantasia Cadastro</label>
                <i v-if="remetCompData && remetData && remetCompData.nome !== remetData.nome"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="fantasiac"
                    v-model="remetCompData.fantasia"
                    type="text"
                    class="form-control"
                    placeholder="Nome Fantasia Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="ruax">Endereço XML</label>
                <div class="position-relative">
                  <input
                      id="ruax"
                      v-model="remetData.rua"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Endereço XML"/>
                  <div class="chat-input-links" v-if="remetData.rua">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="remetCompData.rua = remetData.rua"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="ruac">Endereço Cadastro</label>
                <i v-if="remetCompData && remetData && remetCompData.rua !== remetData.rua"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="ruac"
                    v-model="remetCompData.rua"
                    type="text"
                    class="form-control"
                    placeholder="Endereço Cadastro"/>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="inscricaox">Inscrição Estadual XML</label>
                <div class="position-relative">
                  <input
                      id="inscricaox"
                      v-model="remetData.inscricao"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Inscrição Estadual XML"/>
                  <div class="chat-input-links" v-if="remetData.inscricao">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="remetCompData.inscricao = remetData.inscricao"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="inscricaoc">Inscrição Estadual Cadastro</label>
                <i v-if="remetCompData && remetData && remetCompData.inscricao !== remetData.inscricao"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="inscricaoc"
                    v-model="remetCompData.inscricao"
                    type="text"
                    class="form-control"
                    placeholder="Inscrição Estadual Cadastro"/>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="numerox">Número XML</label>
                <div class="position-relative">
                  <input
                      id="numerox"
                      v-model="remetData.numero"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Número XML"/>
                  <div class="chat-input-links" v-if="remetData.numero">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="remetCompData.numero = remetData.numero"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="numeroc">Número Cadastro</label>
                <i v-if="remetCompData && remetData && remetCompData.numero !== remetData.numero"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="numeroc"
                    v-model="remetCompData.numero"
                    type="text"
                    class="form-control"
                    placeholder="Número Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="cepx">CEP XML</label>
                <div class="position-relative">
                  <input
                      id="cepx"
                      v-model="remetData.cep"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="CEP XML"/>
                  <div class="chat-input-links" v-if="remetData.cep">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="remetCompData.cep = remetData.cep"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="cepc">CEP Cadastro</label>
                <i v-if="remetCompData && remetData && remetCompData.cep !== remetData.cep"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="cepc"
                    v-maska="'##.###-###'"
                    v-model="remetCompData.cep"
                    type="text"
                    class="form-control"
                    placeholder="CEP Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="bairrox">Bairro XML</label>
                <div class="position-relative">
                  <input
                      id="bairrox"
                      v-model="remetData.bairro"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Bairro XML"/>
                  <div class="chat-input-links" v-if="remetData.bairro">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="remetCompData.bairro = remetData.bairro"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="bairroc">Bairro Cadastro</label>
                <i v-if="remetCompData && remetData && remetCompData.bairro !== remetData.bairro"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="bairroc"
                    v-model="remetCompData.bairro"
                    type="text"
                    class="form-control"
                    placeholder="Bairro Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="tel1x">Telefone XML</label>
                <div class="position-relative">
                  <input
                      id="tel1x"
                      v-model="remetData.tel1"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Telefone XML"/>
                  <div class="chat-input-links" v-if="remetData.tel1">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="remetCompData.tel1 = remetData.tel1"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="tel1c">Telefone Cadastro</label>
                <i v-if="remetCompData && remetData && remetCompData.tel1 !== remetData.tel1"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="tel1c"
                    v-maska="'##.#####-####'"
                    v-model="remetCompData.tel1"
                    type="text"
                    class="form-control"
                    placeholder="Telefone Cadastro"/>
              </div>
            </div>
          </div>




          <div class="row">
            <div class="col-md-4">
              <div class="mb-3">
                <label for="municipio">Município</label>
                <input
                    id="municipio"
                    v-model="remetCompData.cidade"
                    type="text"
                    class="form-control"
                    :disabled="true"
                    placeholder="Município"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3">
                <label for="codmun">Código Município</label>
                <input
                    id="codmun"
                    v-model="remetCompData.codmun"
                    type="text"
                    class="form-control"
                    :disabled="true"
                    placeholder="Código Município"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3 text-end">
                <label for="estado">Estado</label>
                <input
                    id="estado"
                    v-model="remetCompData.estado"
                    type="text"
                    class="form-control text-end"
                    :disabled="true"
                    placeholder="Estado"/>
              </div>
            </div>
          </div>


        </div>
      </div>


      <div >
        <!--        <p class="mb-2 mt-5">-->
        <!--          Parâmetros-->
        <!--        </p>-->
        <div class="row">
          <div class="col-md-6">
            <span class="text-primary">Status Fornecedor </span>
            <b-form-checkbox
                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="remetCompData.status">
              {{ remetCompData.status === 'A' ? 'Ativo' : 'Inativo' }}
            </b-form-checkbox>
          </div>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalRemet = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confRemet">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            {{ textConfAlteracoesFornec }}
          </b-button>


        </div>
      </div>
    </b-modal>



    <b-modal size="xl"
             :title="expedCompData && expedCompData.id > 0 ? `Detalhes Expedidor ${expedCompData.cnpj}` : `Detalhes Novo Expedidor`"
             v-model="showModalExped"
             centered hide-footer>
      <div class="col-md-12" v-if="expedData">
        <div class="mb-3">

          <div v-if="expedCompData && expedCompData.id > 0"
               class="mb-5">
            <span>Expedidor encontrado com este CNPJ</span>
            <router-link :to="`/cliente/editar/${expedCompData.id}`" target="_blank" >
              <p class="mb-2">
                Código:
                <span class="text-primary"> {{ expedCompData.codigo }} </span>
              </p>
            </router-link>
          </div>

          <div v-else
               class="mb-5">
            <span>Um Novo Expedidor será cadastrado com este CNPJ</span>

          </div>


          <!--

                                 <div class="col-md-3">

                                  <label for="cnpjemit">CNPJ</label>
                                  <div class="position-relative">
                                    <input
                                        id="cnpjemit"
                                        type="text"
                                        v-model="emitData.cnpj"
                                        class="form-control"
                                        :disabled="true"
                                        placeholder="CNPJ"/>

                                    <div class="chat-input-links" v-if="emitData.cnpj">
                                      <ul class="list-inline mb-0">
                                        <li class="list-inline-item">
                                          <a
                                              href="javascript: void(0);"
                                              v-b-tooltip.hover
                                              placement="top"
                                              title="Consultar CNPJ Dados Públicos">
                                            <i class="mdi mdi-database-search"></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>



                                </div>
          -->

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="nomex">Razão XML</label>
                <div class="position-relative">
                  <input
                      id="nomex"
                      v-model="expedData.nome"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Nome"/>
                  <div class="chat-input-links" v-if="expedData.nome">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="expedCompData.nome = expedData.nome"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="nomec">Razão Cadastro</label>
                <i v-if="expedCompData && expedData && expedCompData.nome !== expedData.nome"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="nomec"
                    v-model="expedCompData.nome"
                    type="text"
                    class="form-control"
                    placeholder="Razão Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="fantasiax">Nome Fantasia XML</label>
                <div class="position-relative">
                  <input
                      id="fantasiax"
                      v-model="expedData.nome"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Nome Fantasia XML"/>
                  <div class="chat-input-links" v-if="expedData.nome">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="expedCompData.nome = expedData.nome"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="fantasiac">Nome Fantasia Cadastro</label>
                <i v-if="expedCompData && expedData && expedCompData.nome !== expedData.nome"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="fantasiac"
                    v-model="expedCompData.fantasia"
                    type="text"
                    class="form-control"
                    placeholder="Nome Fantasia Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="ruax">Endereço XML</label>
                <div class="position-relative">
                  <input
                      id="ruax"
                      v-model="expedData.rua"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Endereço XML"/>
                  <div class="chat-input-links" v-if="expedData.rua">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="expedCompData.rua = expedData.rua"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="ruac">Endereço Cadastro</label>
                <i v-if="expedCompData && expedData && expedCompData.rua !== expedData.rua"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="ruac"
                    v-model="expedCompData.rua"
                    type="text"
                    class="form-control"
                    placeholder="Endereço Cadastro"/>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="inscricaox">Inscrição Estadual XML</label>
                <div class="position-relative">
                  <input
                      id="inscricaox"
                      v-model="expedData.inscricao"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Inscrição Estadual XML"/>
                  <div class="chat-input-links" v-if="expedData.inscricao">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="expedCompData.inscricao = expedData.inscricao"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="inscricaoc">Inscrição Estadual Cadastro</label>
                <i v-if="expedCompData && expedData && expedCompData.inscricao !== expedData.inscricao"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="inscricaoc"
                    v-model="expedCompData.inscricao"
                    type="text"
                    class="form-control"
                    placeholder="Inscrição Estadual Cadastro"/>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="numerox">Número XML</label>
                <div class="position-relative">
                  <input
                      id="numerox"
                      v-model="expedData.numero"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Número XML"/>
                  <div class="chat-input-links" v-if="expedData.numero">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="expedCompData.numero = expedData.numero"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="numeroc">Número Cadastro</label>
                <i v-if="expedCompData && expedData && expedCompData.numero !== expedData.numero"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="numeroc"
                    v-model="expedCompData.numero"
                    type="text"
                    class="form-control"
                    placeholder="Número Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="cepx">CEP XML</label>
                <div class="position-relative">
                  <input
                      id="cepx"
                      v-model="expedData.cep"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="CEP XML"/>
                  <div class="chat-input-links" v-if="expedData.cep">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="expedCompData.cep = expedData.cep"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="cepc">CEP Cadastro</label>
                <i v-if="expedCompData && expedData && expedCompData.cep !== expedData.cep"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="cepc"
                    v-maska="'##.###-###'"
                    v-model="expedCompData.cep"
                    type="text"
                    class="form-control"
                    placeholder="CEP Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="bairrox">Bairro XML</label>
                <div class="position-relative">
                  <input
                      id="bairrox"
                      v-model="expedData.bairro"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Bairro XML"/>
                  <div class="chat-input-links" v-if="expedData.bairro">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="expedCompData.bairro = expedData.bairro"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="bairroc">Bairro Cadastro</label>
                <i v-if="expedCompData && expedData && expedCompData.bairro !== expedData.bairro"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="bairroc"
                    v-model="expedCompData.bairro"
                    type="text"
                    class="form-control"
                    placeholder="Bairro Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="tel1x">Telefone XML</label>
                <div class="position-relative">
                  <input
                      id="tel1x"
                      v-model="expedData.tel1"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Telefone XML"/>
                  <div class="chat-input-links" v-if="expedData.tel1">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="expedCompData.tel1 = expedData.tel1"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="tel1c">Telefone Cadastro</label>
                <i v-if="expedCompData && expedData && expedCompData.tel1 !== expedData.tel1"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="tel1c"
                    v-maska="'##.#####-####'"
                    v-model="expedCompData.tel1"
                    type="text"
                    class="form-control"
                    placeholder="Telefone Cadastro"/>
              </div>
            </div>
          </div>




          <div class="row">
            <div class="col-md-4">
              <div class="mb-3">
                <label for="municipio">Município</label>
                <input
                    id="municipio"
                    v-model="expedCompData.cidade"
                    type="text"
                    class="form-control"
                    :disabled="true"
                    placeholder="Município"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3">
                <label for="codmun">Código Município</label>
                <input
                    id="codmun"
                    v-model="expedCompData.codmun"
                    type="text"
                    class="form-control"
                    :disabled="true"
                    placeholder="Código Município"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3 text-end">
                <label for="estado">Estado</label>
                <input
                    id="estado"
                    v-model="expedCompData.estado"
                    type="text"
                    class="form-control text-end"
                    :disabled="true"
                    placeholder="Estado"/>
              </div>
            </div>
          </div>


        </div>
      </div>


      <div >
        <!--        <p class="mb-2 mt-5">-->
        <!--          Parâmetros-->
        <!--        </p>-->
        <div class="row">
          <div class="col-md-6">
            <span class="text-primary">Status Fornecedor </span>
            <b-form-checkbox
                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="expedCompData.status">
              {{ expedCompData.status === 'A' ? 'Ativo' : 'Inativo' }}
            </b-form-checkbox>
          </div>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalExped = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confExped">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            {{ textConfAlteracoesFornec }}
          </b-button>


        </div>
      </div>
    </b-modal>


    <b-modal size="xl"
             :title="destCompData && destCompData.id > 0 ? `Detalhes Destinatário ${destCompData.cnpj}` : `Detalhes Novo Destinatário`"
             v-model="showModalDest"
             centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">

          <div v-if="destCompData && destCompData.id > 0"
               class="mb-5">
            <span>Destinatário encontrado com este CNPJ</span>
            <router-link :to="`/cliente/editar/${destCompData.id}`" target="_blank" >
              <p class="mb-2">
                Código:
                <span class="text-primary"> {{ destCompData.codigo }} </span>
              </p>
            </router-link>
          </div>

          <div v-else
               class="mb-5">
            <span>Um Novo Destinatário será cadastrado com este CNPJ</span>

          </div>


          <!--

                                 <div class="col-md-3">

                                  <label for="cnpjemit">CNPJ</label>
                                  <div class="position-relative">
                                    <input
                                        id="cnpjemit"
                                        type="text"
                                        v-model="emitData.cnpj"
                                        class="form-control"
                                        :disabled="true"
                                        placeholder="CNPJ"/>

                                    <div class="chat-input-links" v-if="emitData.cnpj">
                                      <ul class="list-inline mb-0">
                                        <li class="list-inline-item">
                                          <a
                                              href="javascript: void(0);"
                                              v-b-tooltip.hover
                                              placement="top"
                                              title="Consultar CNPJ Dados Públicos">
                                            <i class="mdi mdi-database-search"></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>



                                </div>
          -->

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="nomex">Razão XML</label>
                <div class="position-relative">
                  <input
                      id="nomex"
                      v-model="destData.nome"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Nome"/>
                  <div class="chat-input-links" v-if="destData.nome">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="destCompData.nome = destData.nome"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="nomec">Razão Cadastro</label>
                <i v-if="destCompData && destData && destCompData.nome !== destData.nome"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="nomec"
                    v-model="destCompData.nome"
                    type="text"
                    class="form-control"
                    placeholder="Razão Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="fantasiax">Nome Fantasia XML</label>
                <div class="position-relative">
                  <input
                      id="fantasiax"
                      v-model="destData.nome"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Nome Fantasia XML"/>
                  <div class="chat-input-links" v-if="destData.nome">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="destCompData.nome = destData.nome"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="fantasiac">Nome Fantasia Cadastro</label>
                <i v-if="destCompData && destData && destCompData.nome !== destData.nome"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="fantasiac"
                    v-model="destCompData.fantasia"
                    type="text"
                    class="form-control"
                    placeholder="Nome Fantasia Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="ruax">Endereço XML</label>
                <div class="position-relative">
                  <input
                      id="ruax"
                      v-model="destData.rua"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Endereço XML"/>
                  <div class="chat-input-links" v-if="destData.rua">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="destCompData.rua = destData.rua"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="ruac">Endereço Cadastro</label>
                <i v-if="destCompData && destData && destCompData.rua !== destData.rua"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="ruac"
                    v-model="destCompData.rua"
                    type="text"
                    class="form-control"
                    placeholder="Endereço Cadastro"/>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="inscricaox">Inscrição Estadual XML</label>
                <div class="position-relative">
                  <input
                      id="inscricaox"
                      v-model="destData.inscricao"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Inscrição Estadual XML"/>
                  <div class="chat-input-links" v-if="destData.inscricao">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="destCompData.inscricao = destData.inscricao"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="inscricaoc">Inscrição Estadual Cadastro</label>
                <i v-if="destCompData && destData && destCompData.inscricao !== destData.inscricao"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="inscricaoc"
                    v-model="destCompData.inscricao"
                    type="text"
                    class="form-control"
                    placeholder="Inscrição Estadual Cadastro"/>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="numerox">Número XML</label>
                <div class="position-relative">
                  <input
                      id="numerox"
                      v-model="destData.numero"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Número XML"/>
                  <div class="chat-input-links" v-if="destData.numero">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="destCompData.numero = destData.numero"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="numeroc">Número Cadastro</label>
                <i v-if="destCompData && destData && destCompData.numero !== destData.numero"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="numeroc"
                    v-model="destCompData.numero"
                    type="text"
                    class="form-control"
                    placeholder="Número Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="cepx">CEP XML</label>
                <div class="position-relative">
                  <input
                      id="cepx"
                      v-model="destData.cep"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="CEP XML"/>
                  <div class="chat-input-links" v-if="destData.cep">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="destCompData.cep = destData.cep"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="cepc">CEP Cadastro</label>
                <i v-if="destCompData && destData && destCompData.cep !== destData.cep"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="cepc"
                    v-maska="'##.###-###'"
                    v-model="destCompData.cep"
                    type="text"
                    class="form-control"
                    placeholder="CEP Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="bairrox">Bairro XML</label>
                <div class="position-relative">
                  <input
                      id="bairrox"
                      v-model="destData.bairro"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Bairro XML"/>
                  <div class="chat-input-links" v-if="destData.bairro">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="destCompData.bairro = destData.bairro"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="bairroc">Bairro Cadastro</label>
                <i v-if="destCompData && destData && destCompData.bairro !== destData.bairro"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="bairroc"
                    v-model="destCompData.bairro"
                    type="text"
                    class="form-control"
                    placeholder="Bairro Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="tel1x">Telefone XML</label>
                <div class="position-relative">
                  <input
                      id="tel1x"
                      v-model="destData.tel1"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Telefone XML"/>
                  <div class="chat-input-links" v-if="destData.tel1">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="destCompData.tel1 = destData.tel1"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="tel1c">Telefone Cadastro</label>
                <i v-if="destCompData && destData && destCompData.tel1 !== destData.tel1"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="tel1c"
                    v-maska="'##.#####-####'"
                    v-model="destCompData.tel1"
                    type="text"
                    class="form-control"
                    placeholder="Telefone Cadastro"/>
              </div>
            </div>
          </div>




          <div class="row">
            <div class="col-md-4">
              <div class="mb-3">
                <label for="municipio">Município</label>
                <input
                    id="municipio"
                    v-model="destCompData.cidade"
                    type="text"
                    class="form-control"
                    :disabled="true"
                    placeholder="Município"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3">
                <label for="codmun">Código Município</label>
                <input
                    id="codmun"
                    v-model="destCompData.codmun"
                    type="text"
                    class="form-control"
                    :disabled="true"
                    placeholder="Código Município"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3 text-end">
                <label for="estado">Estado</label>
                <input
                    id="estado"
                    v-model="destCompData.estado"
                    type="text"
                    class="form-control text-end"
                    :disabled="true"
                    placeholder="Estado"/>
              </div>
            </div>
          </div>


        </div>
      </div>


      <div >
        <!--        <p class="mb-2 mt-5">-->
        <!--          Parâmetros-->
        <!--        </p>-->
        <div class="row">
          <div class="col-md-6">
            <span class="text-primary">Status Fornecedor </span>
            <b-form-checkbox
                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="destCompData.status">
              {{ destCompData.status === 'A' ? 'Ativo' : 'Inativo' }}
            </b-form-checkbox>
          </div>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalDest = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confDest">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            {{ textConfAlteracoesFornec }}
          </b-button>


        </div>
      </div>
    </b-modal>



    <b-modal size="xl"
             :title="recebCompData && recebCompData.id > 0 ? `Detalhes Recebedor ${recebCompData.cnpj}` : `Detalhes Novo Recebedor`"
             v-model="showModalReceb"
             centered hide-footer>
      <div class="col-md-12" v-if="recebData">
        <div class="mb-3">

          <div v-if="recebCompData && recebCompData.id > 0"
               class="mb-5">
            <span>Recebedor encontrado com este CNPJ</span>
            <router-link :to="`/cliente/editar/${recebCompData.id}`" target="_blank" >
              <p class="mb-2">
                Código:
                <span class="text-primary"> {{ recebCompData.codigo }} </span>
              </p>
            </router-link>
          </div>

          <div v-else
               class="mb-5">
            <span>Um Novo Recebedor será cadastrado com este CNPJ</span>

          </div>


          <!--

                                 <div class="col-md-3">

                                  <label for="cnpjemit">CNPJ</label>
                                  <div class="position-relative">
                                    <input
                                        id="cnpjemit"
                                        type="text"
                                        v-model="emitData.cnpj"
                                        class="form-control"
                                        :disabled="true"
                                        placeholder="CNPJ"/>

                                    <div class="chat-input-links" v-if="emitData.cnpj">
                                      <ul class="list-inline mb-0">
                                        <li class="list-inline-item">
                                          <a
                                              href="javascript: void(0);"
                                              v-b-tooltip.hover
                                              placement="top"
                                              title="Consultar CNPJ Dados Públicos">
                                            <i class="mdi mdi-database-search"></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>



                                </div>
          -->

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="nomex">Razão XML</label>
                <div class="position-relative">
                  <input
                      id="nomex"
                      v-model="recebData.nome"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Nome"/>
                  <div class="chat-input-links" v-if="recebData.nome">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="recebCompData.nome = recebData.nome"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="nomec">Razão Cadastro</label>
                <i v-if="recebCompData && recebData && recebCompData.nome !== recebData.nome"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="nomec"
                    v-model="recebCompData.nome"
                    type="text"
                    class="form-control"
                    placeholder="Razão Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="fantasiax">Nome Fantasia XML</label>
                <div class="position-relative">
                  <input
                      id="fantasiax"
                      v-model="recebData.nome"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Nome Fantasia XML"/>
                  <div class="chat-input-links" v-if="recebData.nome">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="recebCompData.nome = recebData.nome"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="fantasiac">Nome Fantasia Cadastro</label>
                <i v-if="recebCompData && recebData && recebCompData.nome !== recebData.nome"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="fantasiac"
                    v-model="recebCompData.fantasia"
                    type="text"
                    class="form-control"
                    placeholder="Nome Fantasia Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="ruax">Endereço XML</label>
                <div class="position-relative">
                  <input
                      id="ruax"
                      v-model="recebData.rua"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Endereço XML"/>
                  <div class="chat-input-links" v-if="recebData.rua">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="recebCompData.rua = recebData.rua"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="ruac">Endereço Cadastro</label>
                <i v-if="recebCompData && recebData && recebCompData.rua !== recebData.rua"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="ruac"
                    v-model="recebCompData.rua"
                    type="text"
                    class="form-control"
                    placeholder="Endereço Cadastro"/>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="inscricaox">Inscrição Estadual XML</label>
                <div class="position-relative">
                  <input
                      id="inscricaox"
                      v-model="recebData.inscricao"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Inscrição Estadual XML"/>
                  <div class="chat-input-links" v-if="recebData.inscricao">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="recebCompData.inscricao = recebData.inscricao"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="inscricaoc">Inscrição Estadual Cadastro</label>
                <i v-if="recebCompData && recebData && recebCompData.inscricao !== recebData.inscricao"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="inscricaoc"
                    v-model="recebCompData.inscricao"
                    type="text"
                    class="form-control"
                    placeholder="Inscrição Estadual Cadastro"/>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="numerox">Número XML</label>
                <div class="position-relative">
                  <input
                      id="numerox"
                      v-model="recebData.numero"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Número XML"/>
                  <div class="chat-input-links" v-if="recebData.numero">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="recebCompData.numero = recebData.numero"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="numeroc">Número Cadastro</label>
                <i v-if="recebCompData && recebData && recebCompData.numero !== recebData.numero"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="numeroc"
                    v-model="recebCompData.numero"
                    type="text"
                    class="form-control"
                    placeholder="Número Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="cepx">CEP XML</label>
                <div class="position-relative">
                  <input
                      id="cepx"
                      v-model="recebData.cep"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="CEP XML"/>
                  <div class="chat-input-links" v-if="recebData.cep">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="recebCompData.cep = recebData.cep"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="cepc">CEP Cadastro</label>
                <i v-if="recebCompData && recebData && recebCompData.cep !== recebData.cep"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="cepc"
                    v-maska="'##.###-###'"
                    v-model="recebCompData.cep"
                    type="text"
                    class="form-control"
                    placeholder="CEP Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="bairrox">Bairro XML</label>
                <div class="position-relative">
                  <input
                      id="bairrox"
                      v-model="recebData.bairro"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Bairro XML"/>
                  <div class="chat-input-links" v-if="recebData.bairro">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="recebCompData.bairro = recebData.bairro"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="bairroc">Bairro Cadastro</label>
                <i v-if="recebCompData && recebData && recebCompData.bairro !== recebData.bairro"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="bairroc"
                    v-model="recebCompData.bairro"
                    type="text"
                    class="form-control"
                    placeholder="Bairro Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="tel1x">Telefone XML</label>
                <div class="position-relative">
                  <input
                      id="tel1x"
                      v-model="recebData.tel1"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Telefone XML"/>
                  <div class="chat-input-links" v-if="recebData.tel1">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="recebCompData.tel1 = recebData.tel1"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="tel1c">Telefone Cadastro</label>
                <i v-if="recebCompData && recebData && recebCompData.tel1 !== recebData.tel1"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="tel1c"
                    v-maska="'##.#####-####'"
                    v-model="recebCompData.tel1"
                    type="text"
                    class="form-control"
                    placeholder="Telefone Cadastro"/>
              </div>
            </div>
          </div>




          <div class="row">
            <div class="col-md-4">
              <div class="mb-3">
                <label for="municipio">Município</label>
                <input
                    id="municipio"
                    v-model="recebCompData.cidade"
                    type="text"
                    class="form-control"
                    :disabled="true"
                    placeholder="Município"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3">
                <label for="codmun">Código Município</label>
                <input
                    id="codmun"
                    v-model="recebCompData.codmun"
                    type="text"
                    class="form-control"
                    :disabled="true"
                    placeholder="Código Município"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3 text-end">
                <label for="estado">Estado</label>
                <input
                    id="estado"
                    v-model="recebCompData.estado"
                    type="text"
                    class="form-control text-end"
                    :disabled="true"
                    placeholder="Estado"/>
              </div>
            </div>
          </div>


        </div>
      </div>


      <div >
        <!--        <p class="mb-2 mt-5">-->
        <!--          Parâmetros-->
        <!--        </p>-->
        <div class="row">
          <div class="col-md-6">
            <span class="text-primary">Status Fornecedor </span>
            <b-form-checkbox
                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="recebCompData.status">
              {{ recebCompData.status === 'A' ? 'Ativo' : 'Inativo' }}
            </b-form-checkbox>
          </div>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalReceb = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confReceb">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            {{ textConfAlteracoesFornec }}
          </b-button>


        </div>
      </div>
    </b-modal>



    <b-modal v-if="notaItemData"
             title="Importar Novo Produto"
             v-model="showModalNotaItem" hide-footer>

      <div v-if="notaItemData && notaItemData.descprod">


        <form class="needs-validation" @submit.prevent="confProduto">

          <div class="row">




            <div class="col-md-12">
              <div class="mb-3">
                <span>Associar a Produto Existente</span>
                <multiselect id="notaitemProduto"
                             @search-change="pesqProduto"
                             @select="escolheuProduto"
                             v-model="notaItemData.produto"
                             placeholder="Pesquisar novo produto"
                             :options="dtlistPesqProduto"
                             :searchable="true"
                             label="descricao"
                             class="multiselect-size"
                             track-by="descricao"
                             value-prop="codigo">
                  <template #option="slotProps" v-if="dtlistPesqProduto">
                    <div class="row">
                      <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                        <span class="mx-4" >
                    {{ slotProps.option.unidade }}
                  </span>
                        <span class="float-end text-warning" >
                    R$ {{ formatDecimal(slotProps.option.preco) }}
                  </span>
                      </div>
                      <div>
                  <span class="mt-5 font-size-15">
                    {{ slotProps.option.descricao }}
                  </span>
                        <span class="float-end" >

                  </span>
                      </div>
                      <div class="align-items-end text-end align-content-end float-end">

                        <span class="float-end text-success" v-if="slotProps.option.saldo > 0">
                          {{ formatInteger(slotProps.option.saldo) }}
                        </span>

                        <span class="float-end text-danger" v-else>
                    {{ formatInteger(slotProps.option.saldo) }}
                  </span>

                      </div>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
            <div class="row" v-if="loadingProduto">
              <div class="col-12 text-center">
                <b-spinner type="grow"
                           class="m-6 mx-2"
                           variant="secondary"
                           role="status">
                </b-spinner>
                <b-spinner type="grow"
                           class="m-6 mx-2"
                           variant="secondary"
                           role="status">
                </b-spinner>
                <b-spinner type="grow"
                           class="m-6 mx-2"
                           variant="secondary"
                           role="status">
                </b-spinner>
              </div>
            </div>






            <div class="col-lg-12">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 174px;">
                  <div class="d-flex flex-wrap mb-3">

                    <label for="descprod">Descrição Produto</label>
                    <textarea id="descprod"
                              v-model="notaItemData.descprod"
                              type="text"
                              maxlength="500"
                              rows="3"
                              class="form-control"
                              placeholder="Descrição Produto"/>

                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 174px;">
                  <div class="d-flex flex-wrap mb-3">
                    <label for="und">Código</label>
                    <input id="und"
                           v-model="notaItemData.produto"
                           type="text"
                           class="form-control"
                           placeholder="Código"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 174px;">
                  <div class="d-flex flex-wrap mb-3">
                    <label for="und">Unidade</label>
                    <input id="und"
                           v-model="notaItemData.und"
                           type="text"
                           class="form-control"
                           placeholder="Descrição Produto"/>
                  </div>
                </div>
              </div>
            </div>





          </div>


          <div class="row">

            <div class="col-md-6">
              <div class="mb-3">
                <label for="vlrunitliq">Valor Unitário</label>
                <input
                    id="vlrunitliq"
                    v-model="notaItemData.vlrunit"
                    type="number"
                    class="form-control text-end"
                    :disabled="true"
                    placeholder="Valor unitário líquido"/>

              </div>
            </div>


            <div class="col-md-6">
              <div class="mb-3">
                <label for="qtd">Quantidade</label>
                <input
                    id="qtd"
                    v-model="notaItemData.qtd"
                    type="number"
                    class="form-control text-end"
                    :disabled="true"
                    placeholder="Quantidade"/>

              </div>
            </div>

          </div>

        </form>

        <div class="table-responsive mt-2">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Compras Anteriores</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movcte/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Maior compra deste produto (200 und):</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(15000) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Desconto({{ formatDecimal(notaItemData.desconto) }}%):</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(notaItemData.vlrtotalbrt - notaItemData.vlrtotalliq) }}</td>
            </tr>

            </tbody>
          </table>
        </div>



        <div class="row" v-if="notaItemData && notaItemData.produto && notaItemData.produto === 'SEM GTIN'">
          <div class="text-end mt-5 text-danger">

            <span>* Campo código deve ser diferente de SEM GTIN</span>
          </div>
        </div>

        <div class="row">

          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalNotaItem = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button variant="success" class="ms-1" @click="confProduto" :disabled="notaItemData && notaItemData.produto && notaItemData.produto === 'SEM GTIN'">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              {{ notaItemData !== null && notaItemData.idprod ? 'Confirmar Associação a Produto' : 'Confirmar Cadastro de Novo Produto' }}
            </b-button>
          </div>

        </div>

      </div>

    </b-modal>


  </Layout>
</template>
